// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic-wrapper[data-v-59543d04]{padding:16px 18px!important}.topic-wrapper .topic_item img[data-v-59543d04]{height:-webkit-fill-available;-o-object-fit:inherit;object-fit:inherit}", ""]);
// Exports
module.exports = exports;
